import React from 'react';

const ModalMenu = ({ logoimg, linelink, loginstate, onClose, checkurl }) => {
    return (
        <div className="base-modal-overlay x-modal modal -v2 x-theme-switcher-v2 show animated animatedFadeInUp fadeInUp "
            data-v-0c0c7fd4=""
        >
            <div
                className="base-modal pt-0 pb-0 w-100"
                data-v-8bc7c3b9=""
                style={{ margin: 10, textAlign: "-webkit-center" }}
            >
                <div
                    className="modal-dialog -modal-size -v2 modal-dialog-centered modal-dialog-scrollable modal-dialog-centered w-100 m-0"
                    data-v-8bc7c3b9=""
                    style={{ height: "auto" }}
                >


                    <div
                        className="modal-content -modal-content text-white-v1"
                        data-v-8bc7c3b9=""
                    >
                        <a href="/"
                            onClick={(e) => {
                                onClose();
                            }}
                            role="button"
                            className="close-model-head mt-4 mb-4"
                            data-v-8bc7c3b9=""
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={30}
                                height={30}
                                fill="currentColor"
                                className="bi bi-x-circle-fill"
                                viewBox="0 0 16 16"
                                data-v-8bc7c3b9=""
                            >
                                <path
                                    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"
                                    data-v-8bc7c3b9=""
                                />
                            </svg>
                        </a>


                        <div className="pt-3 pb-4 x-theme-switcher-v2 text-center mt-3"
                            data-v-8bc7c3b9=""
                        >
                            <div className="-inner-header-section" data-v-8bc7c3b9="">
                                <img
                                    src={logoimg}
                                    alt=""
                                    data-v-8bc7c3b9=""
                                    style={{ width: 160 }}
                                />
                            </div>
                            {(loginstate != null) ? (!loginstate) ?
                                <div className="row -inner-top-body-section" data-v-8bc7c3b9="">
                                    <div
                                        className="col-6 -wrapper-box"
                                        data-v-8bc7c3b9=""
                                        style={{ paddingLeft: 0 }}
                                    >
                                        <a href="/"
                                            onClick={(e) => {
                                                checkurl(e, "/register")
                                            }}
                                            type="button"
                                            className="btn -btn-item x-transaction-button-v2 -deposit -top-btn -horizontal"
                                            data-v-8bc7c3b9=""
                                        >
                                            <img
                                                alt="img webรูปไอคอนฝากเงิน"
                                                className="img-fluid -icon-image"
                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/279056cb-32d6-4c6d-7291-44366ffa1500/public"
                                                data-v-8bc7c3b9=""
                                            />
                                            <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                <div className="-title" data-v-8bc7c3b9="">
                                                    สมัครสมาชิก
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div
                                        className="col-6 -wrapper-box"
                                        data-v-8bc7c3b9=""
                                        style={{ paddingRight: 0 }}
                                    >
                                        <a href="/"
                                            onClick={(e) => {
                                                checkurl(e, "/signin")
                                            }}
                                            type="button"
                                            className="btn -btn-item x-transaction-button-v2 -withdraw -top-btn -horizontal"

                                            data-v-8bc7c3b9=""
                                        >
                                            <img
                                                alt=" รูปไอคอนถอนเงิน"
                                                className="img-fluid -icon-image"
                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/363edcc3-13dc-460b-671d-6a37e3191e00/public"
                                            />
                                            <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                <div className="-title" data-v-8bc7c3b9="">
                                                    เข้าสู่ระบบ
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div> :
                                <div className="row -inner-top-body-section" data-v-8bc7c3b9="">
                                    <div
                                        className="col-6 -wrapper-box"
                                        data-v-8bc7c3b9=""
                                        style={{ paddingLeft: 0 }}
                                    >
                                        <a href="/"
                                            onClick={(e) => {
                                                checkurl(e, "/deposit")
                                            }}
                                            role="button"
                                            className="btn -btn-item x-transaction-button-v2 -deposit -top-btn -horizontal"
                                            data-v-8bc7c3b9=""
                                        >
                                            <img alt=""
                                                className="img-fluid -icon-image"
                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/d2a5801c-d49e-4e57-ee32-bcb42682e400/public"
                                                data-v-8bc7c3b9=""
                                            />
                                            <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                <div className="-title" data-v-8bc7c3b9="">
                                                    ฝากเงิน
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div
                                        className="col-6 -wrapper-box"
                                        data-v-8bc7c3b9=""
                                        style={{ paddingRight: 0 }}
                                    >
                                        <a href="/"
                                            onClick={(e) => {
                                                checkurl(e, "/withdraw")
                                            }}
                                            type="button"
                                            className="btn -btn-item x-transaction-button-v2 -withdraw -top-btn -horizontal"
                                        >
                                            <img alt=""
                                                className="img-fluid -icon-image"
                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6829da4a-a4a5-4f8e-2ce0-286825809600/public"
                                            />
                                            <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                                <div className="-title" data-v-8bc7c3b9="">
                                                    ถอนเงิน
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div> : ""}
                            <div
                                className="row -inner-center-body-section m-0"
                                data-v-8bc7c3b9=""
                            >
                                <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                    <a href="/"
                                        onClick={(e) => {
                                            checkurl(e, "/promotion")
                                        }}
                                        role="button"
                                        className="btn -btn-item -promotion-button -menu-center -horizontal"
                                        data-v-8bc7c3b9=""
                                    >
                                        <img
                                            alt=" รูปไอคอนโปรโมชั่น"
                                            className="img-fluid -icon-image ls-is-cached lazyloaded"
                                            data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                            data-v-8bc7c3b9=""
                                        />
                                        <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                            <div className="-typo -is-logged" data-v-8bc7c3b9="">
                                                โปรโมชั่น
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                    <a
                                        href={linelink}
                                        role="button"
                                        className="btn -btn-item -line-button -menu-center -horizontal"
                                        rel="noopener nofollow"
                                        data-v-8bc7c3b9=""
                                    >
                                        <picture data-v-8bc7c3b9="">
                                            <source
                                                type="image/webp"
                                                data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a5205298-bde9-4817-4f93-32dc3822b700/public"
                                                srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a5205298-bde9-4817-4f93-32dc3822b700/public"
                                                data-v-8bc7c3b9=""
                                            />
                                            <source
                                                type="image/png?v=1"
                                                data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a5205298-bde9-4817-4f93-32dc3822b700/public"
                                                srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a5205298-bde9-4817-4f93-32dc3822b700/public"
                                                data-v-8bc7c3b9=""
                                            />
                                            <img alt=""
                                                className="img-fluid -icon-image ls-is-cached lazyloaded"
                                                data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a5205298-bde9-4817-4f93-32dc3822b700/public"
                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a5205298-bde9-4817-4f93-32dc3822b700/public"
                                                data-v-8bc7c3b9=""
                                            />
                                        </picture>
                                        <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                            <div className="-typo -is-logged" data-v-8bc7c3b9="">
                                                ติดต่อ
                                            </div>
                                        </div>
                                    </a>
                                </div>

                                <div className="col-12 -wrapper-box" data-v-8bc7c3b9="">
                                    <div
                                        className="btn -btn-item -line-button -menu-center -horizontal"
                                        data-v-8bc7c3b9=""
                                    >
                                        <div className="mt-1 mb-1 w-100" data-v-8bc7c3b9="">
                                            <h3 className="title-footer-wrap pt-2">
                                                <b>Language / ภาษา </b>
                                            </h3>
                                            <ul className="logo-list-footer">
                                                <li role="button">
                                                    <img
                                                        className="lang-img active-lang"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e1626da-cc1f-451f-838f-54e5e1848f00/public"
                                                        alt=""
                                                    />
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br data-v-8bc7c3b9="" />
                            <br data-v-8bc7c3b9="" />
                            <br data-v-8bc7c3b9="" />
                            <br data-v-8bc7c3b9="" />
                            <br data-v-8bc7c3b9="" />
                            <br data-v-8bc7c3b9="" />
                            <br data-v-8bc7c3b9="" />
                            <br data-v-8bc7c3b9="" />
                            <br data-v-8bc7c3b9="" />
                            <br data-v-8bc7c3b9="" />
                            <br data-v-8bc7c3b9="" />
                            <br data-v-8bc7c3b9="" />
                            <br data-v-8bc7c3b9="" />
                        </div>



                    </div>
                </div>
            </div>

        </div>
    );
};

export default ModalMenu;
